import { render } from "./ServiceQuarantineDurationDialog.vue?vue&type=template&id=66e9c2a4"
import script from "./ServiceQuarantineDurationDialog.vue?vue&type=script&lang=js"
export * from "./ServiceQuarantineDurationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__